import { IAuthDecorator } from 'decorators/AuthDecorator';
import { API_URLS } from 'constants/apiUrls';

export default class BalanceRepository {
    constructor(private readonly repository: IAuthDecorator) {}

    public fetch(): Promise<string> {
        return this.repository.get<string>(API_URLS.BALANCE);
    }
}
